/* @flow */
import React from 'react';
// $FlowIgnore
import { MdLockOpen } from 'react-icons/md';

export default function OpenIcon({
  style
}: Object): React.Element {
  return <MdLockOpen style={style} />;
}
